<script>
    // @ts-nocheck

    import { Button, Typography, InputFile } from '$lib/components/UI'
    import { createEventDispatcher } from 'svelte'
    import { API_URL } from '$lib/conf'
    export let value = {}
    export let title = ''
    export let legend = ''
    export let name = ''
    export let button_label = ''
    export let allowMediaType = ['pdf']
    export let minDocuments = 1
    export let maxDocuments = 1
    export let maxFileSize = 0
    export let disabled = false
    export let form = {}
    export let valid = true
    export let preprocess = (x) => x
    export let lock = false
    export let validation = (_) => true
    const dispatch = createEventDispatcher()
    let _value = value
    let _valid = {}
    function onSubmit() {
        dispatch('submit', { ...value })
    }
    function validationDoc(d) {
        let rgx = new RegExp(`^.*\.(${allowMediaType.join('|')})$`, 'i')
        return (
            d instanceof Array &&
            d.length >= minDocuments &&
            d.length <= maxDocuments &&
            d.every((f) => rgx.test(f?.filename) || false)
        )
    }

    $: value = preprocess(_value)
    $: valid = validation(value) && (name ? _valid[name] : true)
    $: console.log({ _value, _valid, value, valid })
    $: multi = _value[name] instanceof Array && maxDocuments > 1
    $: errMsg = `Por favor cargue al menos ${minDocuments} documentos en formato ${allowedTxt(allowMediaType)} (${maxDocuments} como máximo)` || `Carge un documento en formato ${allowedTxt(allowMediaType)}`

    const allowedTxt = (list, art='y') => {
        let r = '', rlist = list.map(x => x.toUpperCase())
        if(rlist.length == 1) {
            r = rlist[0]
        } else if(rlist.length == 2) {
            r = rlist[0] + ` ${art} ` + rlist[1]
        } else if(rlist.length > 2) {
            r = rlist.slice(0, -1).join(', ') + ` ${art} ` + rlist.at(-1)
        }
        return r
    }
    const Multiplos = {
        k: 10**3,
        M: 10**6,
        G: 10**9,
        T: 10**12
    }
    const Units = {
        b: 1/8,
        B: 1
    }
    const solveSize = (i) => {
        let rgx = /(?<n>\d+)\s*(?<m>[A-z])(?<u>[A-z])/
        if(typeof i === 'number') return i
        if(typeof i === 'string') {
            let match = rgx.exec(i)
            if (match && match.groups) {
                let {n, m, u} = match.groups
                if ([m in Multiplos, u in Units].every(x => x)) {
                    return parseFloat(n) * Multiplos[m] * Units[u]
                } else {
                    throw new Error('Unknow multiplo or unit memory.')
                }
            } else {
                throw new Error('Invalid format.')
            }
        }
    }
    const getSize = (bytes, format='kB') => {
        let rgx = /(?<m>[A-z])(?<u>[A-z])/
        let match = rgx.exec(format)
        if (match && match.groups) {
            let {m, u} = match.groups
            if ([m in Multiplos, u in Units].every(x => x)) {
                return `${(bytes / Multiplos[m]) / Units[u]}${format}`
            } else {
                throw new Error('Unknow multiplo or unit memory.')
            }
        } else {
            throw new Error('Invalid format.')
        }

    }

    function validationFileItem(item) {
        let ret = true
        let rmaxFileSize = typeof maxFileSize  == 'string' || (typeof maxFileSize  == 'number' && maxFileSize > 0) ? solveSize(maxFileSize) : null
        if(rmaxFileSize) {
            if(item.size > rmaxFileSize) {
                ret = `No se pueden subir documentos que superen los ${getSize(rmaxFileSize, 'kB')}`
            }
        }
        console.log({ret, item, maxFileSize, rmaxFileSize})
        return ret
    }
</script>

<div>
    {#if !lock}
        {#if title}
            <Typography style="margin: 0">{title}</Typography>
        {/if}

        <!-- validation={d => d instanceof Array && d.length > 0 && d.every(f => isPdf(f?.filename) || false)} -->
        <!-- errMsg={`Por favor cargue ${multi ? 'documentos (al menos ' + String(minDocuments) + ' y ' + String(maxDocuments) +' como maximo)' : 'un documento'} en formato ${allowedTxt(allowMediaType, "o")}`} -->
        <InputFile
            {legend}
            {errMsg}
            endpoint={`${API_URL}/upload`}
            allowExt={allowMediaType}
            maxFiles={maxDocuments}
            {maxFileSize}
            plusButtonLabel="Agregar documentación respaldatoria"
            style="flex-direction: column; justify-content: space-between; padding: 5px 15px"
            validation={validationDoc}
            bind:value={_value[name]}
            bind:valid={_valid[name]}
            {multi}
        />
        {#each Object.entries(form) as [field, { props, type }] (field)}
            <svelte:component
                this={type}
                {...props}
                bind:value={_value[field]}
                bind:valid={_valid[field]}
            />
        {/each}
        <Button
            size="small"
            disabled={!valid || disabled}
            on:click={onSubmit}
            style="width: fit-content"
            label={button_label}
        />
    {:else}
        <slot name="lockedView"/>
    {/if}
</div>

<style>
    div {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
</style>
